import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { useState } from "react";

export const useTableCoreFunctions = () => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const renderActivoIcon = (isActive: boolean): React.ReactNode => {

        return renderCheckTimesIcon(isActive, 'Activo', 'Inactivo');

    };

    const renderYesNo = (isActive: boolean): React.ReactNode => {

        return renderCheckTimesIcon(isActive, 'Si', 'No');

    };

    const renderCheckTimesIcon = (isActive: boolean, labelYes: string, labelNo: string) => {

        return (
            <Typography variant="body1" color={isActive ? "#059142" : "#8A0303"}>
                <FontAwesomeIcon icon={isActive ? faCheckCircle : faTimesCircle} /> {isActive ? `${labelYes}` : `${labelNo}`}
            </Typography>
        );

    }

    return [
        page,
        rowsPerPage,
        handleChangePage,
        renderActivoIcon,
        handleChangeRowsPerPage,
        renderYesNo
    ] as const;

}